import React from "react";
import Heroes from "../components/Organisms/Heroes";
import ListMusic from "../components/Organisms/ListMusic";

export default function LandingPage() {


  return (
    <>
      <Heroes />
      <ListMusic />
    </>
  );
}
